import { render, staticRenderFns } from "./MedicationGroupCheck.vue?vue&type=template&id=4b5a8d7c&scoped=true&"
import script from "./MedicationGroupCheck.vue?vue&type=script&lang=js&"
export * from "./MedicationGroupCheck.vue?vue&type=script&lang=js&"
import style0 from "./MedicationGroupCheck.vue?vue&type=style&index=0&id=4b5a8d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a8d7c",
  null
  
)

export default component.exports